
import axios from 'axios';

// app config
import AppConfig from 'Constants/AppConfig';
import AuthHeader from 'Constants/AuthHeader';
import {
    CUMULATIVEREPORT_ACTION,
    ALL_CUMULATIVEREPORT,

} from 'Actions/types';

/**
 * MSK Findings Chart Actions
 */

   export const allCumulativeReport = (startdate,enddate,student) =>{
    
    var payload={
        "studentID":student,
        "startdate":startdate,
        "enddate":enddate
    }
    return (dispatch) => { 
        dispatch({ type:CUMULATIVEREPORT_ACTION, });
        return axios.post(AppConfig.apiurl+'/api/overalltravelreport', payload,{ headers: AuthHeader.header })         
        .then(response => {             
            const allCumulativeReport=response.data.data;
            dispatch({ type:ALL_CUMULATIVEREPORT, payload: allCumulativeReport });
        });
    
    }
}

